import * as angular from 'angular';

export class EnumService {
    private static specialNames: { [id: string]: string } = {
        'AdSubmission': 'Ad submission',
        'QualityControl': 'Quality control'
    };

    public RetailerStatus = {
        Unverified: 0,
        Verified: 1,
        Suspended: 2,
        Closed: 3,
        Template: 4,
        getName: this.getNameByValue
    };

    public BusinessType = {
        All: -666,
        Shop: 1,
        ShoppingCentre: 2,
        Restaurant: 3,
        Attraction: 4,
        Accommodation: 5,
        Education: 6,
        Exhibition: 7,
        Exhibitor: 8,
        DigitalContentPublisher: 11,
        getName: this.getNameByValue
    };

    public ClassificationCategoryBrandStatus = {
        Pending: 0,
        Rejected: 1,
        Approved: 2,
        getName: this.getNameByValue
    };

    public CampaignType = {
        Offer: 1,
        Promotion: 2,
        Advert: 3,
        FlashSale: 4,
        Event: 5,
        Voucher: 6,
        ExclusiveOffer: 7,
        SpecialEvent: 8,
        getName: this.getNameByValue
    };

    public CampaignStatus = {
        Running: 1,
        Archived: 2,
        Completed: 3,
        Error: 4,
        Disabled: 5,
        Warning: 6,
        Scheduled: 7,
        Draft: 8,
        AdSubmission: 9,
        QualityControl: 10,
        Undefined: 13,
        VideoProcessing: 14,
        VideoProcessingError: 15,
        getName: this.getNameByValue
    };

    public VideoStatus = {
        Added: 1,
        Uploaded: 2,
        Processing: 3,
        ProcessingError: 4,
        Processed: 5,
        getName: this.getNameByValue
    };

    public BillingTransactionReason = {
        Schedule: 0,
        LimitReached: 1,
        Retry: 2,
        JispPayCommissionThreshold: 3,
        JispPayCommissionRefund: 4,
        getName: this.getNameByValue
    };

    public BillingConfiguration = {
        ChargeLimit: 250
    };

    public TimelineListItemType = {
        Campaign: 1,
        Store: 2,
        SavedProduct: 3,
        ViewedProduct: 4,
        Note: 5,
        Pay: 6,
        Refund: 7,
        ViewedStoreProduct: 8,
        Coupon: 9,
        CompetitionVoucher: 10,
        CompetitionPrize: 11,
        CompetitionCashPot: 12,
        AdminMessage: 13,
        Video: 14,
        LoyaltyEarn: 15,
        InfoTag: 16,
        Article: 17,
        getName: this.getNameByValue
    };

    public TimelineFilterItemType = {
        Places: 1,
        Offers: 2,
        SavedProducts: 4,
        ViewedProducts: 8,
        Note: 16,
        JispPay: 32,
        JispRefund: 64,
        ViewedStoreProducts: 128,
        Coupons: 256,
        Competition: 512,
        AdminMessages: 1024,
        Video: 2048,
        // Loyalty: 4096,
        InfoTags: 8192,
        getName: this.getNameByValue
    };

    public TimelineFilterItems = {
        All: this.TimelineFilterItemType.Places + this.TimelineFilterItemType.Offers + this.TimelineFilterItemType.SavedProducts +
            this.TimelineFilterItemType.ViewedProducts + this.TimelineFilterItemType.ViewedStoreProducts +
            this.TimelineFilterItemType.Note + this.TimelineFilterItemType.JispPay + this.TimelineFilterItemType.JispRefund +
            this.TimelineFilterItemType.Coupons + this.TimelineFilterItemType.Competition + this.TimelineFilterItemType.Video +
            /* this.TimelineFilterItemType.Loyalty + */ this.TimelineFilterItemType.InfoTags,
        Places: this.TimelineFilterItemType.Places,
        Offers: this.TimelineFilterItemType.Offers,
        SavedProductsAndLinks: this.TimelineFilterItemType.SavedProducts,
        ViewedProducts: this.TimelineFilterItemType.ViewedProducts + this.TimelineFilterItemType.ViewedStoreProducts,
        Note: this.TimelineFilterItemType.Note,
        JispPayReceipts: this.TimelineFilterItemType.JispPay + this.TimelineFilterItemType.JispRefund,
        Coupons: this.TimelineFilterItemType.Coupons,
        Competition: this.TimelineFilterItemType.Competition,
        Video: this.TimelineFilterItemType.Video,
        // Loyalty: this.TimelineFilterItemType.Loyalty,
        InfoTags: this.TimelineFilterItemType.InfoTags,
        getName: this.getNameByValue
    };

    public CampaignContentType = {
        // Html: 1,
        Image: 2,
        Video: 3,
        Gif: 4
    };

    public TimelineProductType = {
        Product: 1,
        Page: 2
    };

    public RefundType = {
        Partial: 1,
        Full: 2
    };

    public VoucherRedemptionStatus = {
        Requested: 1,
        Confirmed: 2,
        Rejected: 3,
        Refunded: 4,
        getName: this.getNameByValue
    };

    public DailyRewardType = {
        CashPot: 1,
        Prize: 2
    };

    public CompetitionPrizeStatus = {
        NotClaimed: 1,
        Claimed: 2,
        Dispatched: 3,
        Rejected: 4
    };

    public Gender = {
        Male: 1,
        Female: 2
    };

    public MeasurementType = {
        Neck: 1,
        Chest: 2,
        Bust: 3,
        Waist: 4,
        Hips: 5,
        InsideLeg: 6,
        Shoe: 7,
        LegLength: 8,
        Dress: 9
    };

    public SentimentType = {
        LoveIt: 1,
        Dislike: 2,
        Interesting: 8
    };

    public RetailerPermission = {
        Retailer: 1,
        StoreManager: 2,
        Nfrn: 3,
        Publisher: 4
    };

    public PhysicalProductState = {
        Unassigned: 0,
        NotArchived: 1,
        Archived: 2,
        Active: 3
    };

    public PhysicalProductTagAssignedType = {
        AllAllowed: 0,
        ArchivedAllowed: 1,
        NoAllowed: 2,
    };

    public CampaignEntityStatus = {
        Draft: 1,
        AdSubmission: 2,
        QualityControl: 3,
        Active: 4,
        Archived: 5
    };

    public ExportFileType = {
        CSV: 1,
        PDF: 2,
        ZIP: 3,
        EPUB: 4,
        SVG: 5
    };

    public NfcScanStatus = {
        Success: 1,
        EmptyCart: 2,
        VerificationRequired: 3,
        Error: 4,
        CartError: 5
    };

    public ProductScanAction = {
        AddToCart: 1,
        ShowDetails: 2,
        FlickeringCards: 3,
        TapTap: 4
    };

    public StorePaymentMethod = {
        TapAndGo: 1,
        ClickCollectOrInStore: 2,
        ClickCollectOrTapAndGo: 3
    };

    public OfferAudienceMapping = {
        interests: {
            '1': 'reading',
            '2': 'movies',
            '3': 'technology',
            '4': 'pets',
            '5': 'gardening',
            '6': 'food',
            '7': 'home furnishing',
            '8': 'cars',
            '9': 'beauty',
            '10': 'sports',
            '11': 'the outdoors',
            '12': 'fashion',
            '13': 'arts & crafts',
            '14': 'music',
            '15': 'DIY',
            '16': 'health & wellbeing',
            '17': 'toys',
            '18': 'parenting',
            '19': 'gaming',
            '20': 'internet culture'
        },
        genders: {
            '1': 'male',
            '2': 'female'
        },
        ages: {
            '1': 'Under 18',
            '2': '18-20',
            '3': '21-29',
            '4': '30-39',
            '5': '40-50',
            '6': 'Over 50'
        }
    };

    private getNameByValue(value: number): string {
        for (var c in this) {
            if (this[<string>c] === value) {
                return EnumService.specialNames[c] || c;
            }
        }
        return null;
    }
}

angular.module('app.common').service('enumService', EnumService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/enum.service.ts